import apiRequestType from "../apiRequestType";
import { apiTypes } from "../../utils/apiTypes";
import { apiConstants } from "../../utils/apiConstants";

const getRecentlyAddedPrograms = (
  Condition,
  Status,
  classtype,
  filters,
  isPublishedContentOnly,
  locale,
  pageNum,
  pageSize
) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.ORGANIZE.GET_RECENTLY_ADDED_PROGRAMS(
      Condition,
      Status,
      classtype,
      filters,
      isPublishedContentOnly,
      locale,
      pageNum,
      pageSize
    )
  );
};

export default getRecentlyAddedPrograms;
